var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrmLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 158,
    viewBox: "0 0 189 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M182.683 94.1346C182.044 91.7904 178.787 82.045 168.431 76.2175C160.816 71.9308 151.477 72.648 151.477 72.648C151.477 72.648 142.137 71.9308 134.522 76.2175C124.166 82.045 120.909 91.7904 120.27 94.1346C118.841 99.3802 117.21 114.965 116.498 120.699C118.099 129.506 144.533 130.366 151.477 130.366C158.42 130.366 184.854 129.506 186.455 120.699C185.743 114.965 184.112 99.3802 182.683 94.1346Z",
    fill: "#9BDC50",
    stroke: "#15203D",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M68.7132 94.1346C68.0742 91.7904 64.8175 82.045 54.4619 76.2175C46.8468 71.9308 37.507 72.648 37.507 72.648C37.507 72.648 28.1673 71.9308 20.5521 76.2175C10.1965 82.045 6.93987 91.7904 6.30084 94.1346C4.8712 99.3802 3.24085 114.965 2.52808 120.699C4.12976 129.506 30.5637 130.366 37.507 130.366C44.4504 130.366 70.8843 129.506 72.486 120.699C71.7732 114.965 70.1428 99.3802 68.7132 94.1346Z",
    fill: "#9BDC50",
    stroke: "#15203D",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M94.4917 68.2506C112.64 68.2506 127.353 53.5318 127.353 35.3753C127.353 17.2188 112.64 2.5 94.4917 2.5C76.343 2.5 61.6306 17.2188 61.6306 35.3753C61.6306 53.5318 76.343 68.2506 94.4917 68.2506Z",
    fill: "#9BDC50",
    stroke: "#15203D",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M151.476 68.2546C164.799 68.2546 175.6 57.4495 175.6 44.1207C175.6 30.7918 164.799 19.9867 151.476 19.9867C138.153 19.9867 127.353 30.7918 127.353 44.1207C127.353 57.4495 138.153 68.2546 151.476 68.2546Z",
    fill: "#9BDC50",
    stroke: "#15203D",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M37.5071 68.2546C50.8302 68.2546 61.6306 57.4495 61.6306 44.1207C61.6306 30.7918 50.8302 19.9867 37.5071 19.9867C24.184 19.9867 13.3835 30.7918 13.3835 44.1207C13.3835 57.4495 24.184 68.2546 37.5071 68.2546Z",
    fill: "#9BDC50",
    stroke: "#15203D",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M139.249 103.486C138.331 100.122 133.657 86.1472 118.808 77.787C107.883 71.6398 94.4917 72.6684 94.4917 72.6684C94.4917 72.6684 81.1006 71.6398 70.1756 77.787C55.3221 86.1431 50.6482 100.122 49.7347 103.486C47.6865 111.011 45.3475 133.362 44.3234 141.587C46.6214 154.217 84.5375 155.451 94.4917 155.451C104.446 155.451 142.362 154.217 144.66 141.587C143.636 133.362 141.297 111.011 139.249 103.486Z",
    fill: "#9BDC50",
    stroke: "#15203D",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrmLogo);
export default __webpack_public_path__ + "static/media/CRM_logo.010a3c87a3b4eaf8774d55d862bc7889.svg";
export { ForwardRef as ReactComponent };